import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import { useStyles } from '../../theme/VelocityHubMaterial';

function SpotlightButton({ onClick, text }) {
  const { classes } = useStyles();

  return (
    <Button variant="contained" className={classes.spotlightButton} type="submit" onClick={onClick}>
      {text}
    </Button>
  );
}

SpotlightButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
};

export default SpotlightButton;
